// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"c8fa213a","703":"ff570e2d"}[chunkId] + ".chunk.js";
};